export interface FAQ {
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    question: '禁漫天堂是什么？',
    answer: '禁漫天堂是一个广受用户关注的成人漫画在线阅读平台，汇集了来自日本、韩国、中国以及欧美等地区的大量成人漫画作品。平台提供免费和会员两种使用模式，支持网页端和移动端访问，致力于为成熟用户提供优质的漫画阅读体验。',
  },
  {
    question: '禁漫天堂的最新入口地址是什么？',
    answer: '禁漫天堂的入口地址可能会因网络环境变化而调整。建议收藏本站的"最新入口地址"页面，我们会持续更新当前可用的域名和备用访问链接。当前可用的主域名可在本站首页或"使用教程"分类中查看。',
  },
  {
    question: '禁漫天堂是否需要注册才能使用？',
    answer: '禁漫天堂提供免费浏览模式，游客可以直接访问和阅读部分内容。但注册账号后可以享受更多功能，包括收藏漫画、参与评论、获得每日免费阅读额度等。VIP会员则享有更多专属权益。',
  },
  {
    question: '禁漫天堂是否免费？',
    answer: '禁漫天堂采用免费与付费相结合的模式。免费用户可以浏览所有公开的漫画作品，每日有一定次数的免费阅读额度。VIP和SVIP会员享有无限阅读、去广告、高清画质、离线下载等更多高级功能。',
  },
  {
    question: '如何在禁漫天堂中搜索漫画？',
    answer: '登录禁漫天堂后，你可以在页面顶部的搜索栏中输入关键词（如漫画名称、作者名、标签等）进行搜索。平台也支持按分类浏览、按更新时间和人气排序等功能，帮助你快速找到感兴趣的漫画。',
  },
  {
    question: '禁漫天堂的漫画多久更新一次？',
    answer: '更新频率因作品而异。热门连载漫画通常每周或每两周更新一次，完结作品则可以直接阅读全集。你可以在作品详情页查看具体的更新状态。关注作品后，更新时会收到通知提醒。',
  },
  {
    question: '禁漫天堂有哪些内容分类？',
    answer: '禁漫天堂的内容分类非常丰富，主要包括：热门推荐、日漫专区、韩漫专区、国漫专区、欧美专区、3D漫画、同人作品、完结作品等。每个分类下还有更细致的标签筛选，方便用户快速定位感兴趣的内容。',
  },
  {
    question: '禁漫天堂是否支持移动端阅读？',
    answer: '是的，禁漫天堂提供官方移动端APP，支持Android和iOS双平台。APP针对手机屏幕进行了优化，提供流畅的竖屏阅读体验，同时支持离线下载功能（VIP及以上会员可享）。你也可以直接通过手机浏览器访问网页版。',
  },
  {
    question: '注册禁漫天堂账号需要什么信息？',
    answer: '注册禁漫天堂账号只需提供一个有效的电子邮箱地址即可，无需手机号。注册流程简单快捷：填写用户名、邮箱和密码，完成邮箱验证后即可正常使用。平台也会严格保护用户个人信息安全。',
  },
  {
    question: '禁漫天堂如何保障用户隐私安全？',
    answer: '禁漫天堂采用业界标准的加密技术保护用户数据，包括传输过程中的SSL/TLS加密和存储时的数据加密。平台承诺不会将用户的个人信息泄露给第三方，也不会在用户未授权的情况下收集和使用个人数据。详细的隐私政策可在官网查阅。',
  },
  {
    question: '忘记密码应该如何找回？',
    answer: '如果你忘记了登录密码，可以在登录页面点击"忘记密码"链接，输入注册时使用的邮箱地址。系统会向该邮箱发送密码重置链接，点击链接后按照提示设置新密码即可。如果未收到邮件，请检查垃圾邮件文件夹。',
  },
  {
    question: '禁漫天堂支持哪些付费方式？',
    answer: '禁漫天堂支持多种付费方式：国内用户可以使用支付宝、微信支付和银联卡；国际用户可以使用Visa、Mastercard等信用卡以及部分地区的本地支付方式。会员套餐分为月付、季付和年付三种，年付套餐性价比最高。',
  },
];